import { LabelColor } from '@shared/components';

export const QUESTION_REVIEW_BORDER_COLOR = {
  todo: LabelColor.INFO,
  'in-review': LabelColor.WARNING,
  reviewed: LabelColor.SUCCESS,
  done: LabelColor.SUCCESS,
};
